/**
 * NT-CRIMEOPS-FIX-01/B1: reine, DOM-freie Filterlogik für die Trennung zwischen "Angebot, noch
 * nicht angenommen" (nur bei den Auftraggeber-Karten sichtbar) und "angenommener, laufender
 * Auftrag" (Sektion AKTIVE AUFTRÄGE) — ausgelagert aus crimeOps.ts (Muster
 * dashboard.betriebe-shortcuts.ts/crimeOps.categories.ts), damit die Kernregel isoliert testbar
 * ist, ohne den restlichen, seiteneffektreichen Crime-Ops-Code zu laden.
 */

/** Minimaler Ausschnitt aus NpcOrderItem (crimeOps.ts), den diese Logik tatsächlich braucht. */
export interface OrderStatusItem {
  status: 'OPEN' | 'ACCEPTED' | 'PARTIAL' | 'DONE' | 'EXPIRED' | 'FAILED';
}

/**
 * Ein Auftrag gilt als "laufend" (gehört in AKTIVE AUFTRÄGE), sobald er das OPEN-Stadium
 * verlassen hat — d. h. er wurde tatsächlich angenommen (ACCEPTED) oder es wurde bereits
 * geliefert (PARTIAL). Ein nie angeklicktes Angebot (OPEN) erscheint NICHT hier, sondern nur
 * oben bei den Auftraggebern.
 */
export function isOrderRunning(order: OrderStatusItem): boolean {
  return order.status !== 'OPEN';
}

/** Filtert eine beliebige Auftragsliste auf die tatsächlich laufenden (angenommenen) Aufträge. */
export function selectRunningOrders<T extends OrderStatusItem>(orders: readonly T[]): T[] {
  return orders.filter(isOrderRunning);
}

/**
 * Ein Auftrag braucht eine ANNEHMEN/ABLEHNEN-Entscheidung genau dann, wenn er noch OPEN ist.
 * Typ-Guard statt einfachem `boolean`, damit `currentOrder` am Aufrufort (Template-Interpolation
 * mit `currentOrder.id`) korrekt auf non-null verengt bleibt.
 */
export function needsOrderDecision<T extends OrderStatusItem>(order: T | null): order is T {
  return order !== null && order.status === 'OPEN';
}
